<template>
  <div>
    <q-toolbar v-if="customers.length || isTemporaryResult" color="white" text-color="grey-9" class="top-page-toolbar">
      <q-toolbar-title>
        <div class="row items-center">
          <div class="top-page-toolbar__type-filter">
            <q-select
              v-model="customerFilter"
              :options="filterOptions"
              @input="this.filterCustomerType"
              color="grey-9"
              radio
              hide-underline
            />
          </div>
        </div>
      </q-toolbar-title>

      <q-icon name="more_vert">
        <customer-popover :customers="checkedCustomers" multiple></customer-popover>
      </q-icon>
    </q-toolbar>
    <div class="layout-padding">
      <div v-if="customers.length" class="row gutter-sm">
        <div class="col" :class="{ 'col-xl-4': selectedCustomer }">
          <customer-table class="bg-white overflow-hidden"/>
        </div>

        <div v-if="selectedCustomer" class="col-xl-8">
          <router-view></router-view>
        </div>
      </div>

      <template v-else>
        <div class="row justify-center items-center col-grow q-pt-lg">
          <div class="text-center">
            <img src="~assets/emptystates/contacts_empty.svg"/>

            <h6 class="q-my-md text-faded">{{ $t('no_partners') }}</h6>

            <q-btn-dropdown :label="$t('create_partner')" color="primary" class="q-mt-lg" outline>
              <q-list link>
                <q-item @click.native="$refs.customerModal.handleAddCustomer('person')" v-close-overlay>
                  <q-item-main :label="$tc('person', 1)"/>
                </q-item>

                <q-item @click.native="$refs.customerModal.handleAddCustomer('company')" v-close-overlay>
                  <q-item-main :label="$tc('company', 1)"/>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          </div>
        </div>
      </template>
    </div>

    <add-customer-modal ref="customerModal" v-is-user/>
    <customer-export-modal ref="customerExportModal"></customer-export-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import AddCustomerModal from 'components/Customers/AddCustomerModal.vue'
  import CustomerExportModal from 'components/Customers/CustomerExportModal.vue'
  import CustomerPopover from 'components/Customers/CustomerPopover.vue'
  import CustomerTable from 'components/Customers/CustomerTable.vue'
  import { Notify } from 'quasar'
  import i18n from 'src/i18n/i18n'
  import store from 'src/store/index'

  export default {
    data () {
      return {
        meta: null,
        initialLoadFinished: false,
        customerFilter: 'both',
        filterOptions: [
          {
            label: this.$t('persons_and_companies'),
            value: 'both'
          },
          {
            label: this.$tc('company', 2),
            value: 'company'
          },
          {
            label: this.$tc('person', 2),
            value: 'person'
          }
        ]
      }
    },

    computed: {
      ...mapGetters(['customers', 'selectedCustomer', 'checkedCustomers']),

      isTemporaryResult () {
        return this.customerFilter !== 'both'
      }
    },

    methods: mapActions(['deselectCustomer', 'clearCheckedCustomers', 'filterCustomerType']),

    mounted () {
      if (this.$route.name === 'create-person') {
        this.$refs.customerModal.handleAddCustomer('person')
      } else if (this.$route.name === 'create-company') {
        this.$refs.customerModal.handleAddCustomer('company')
      }
    },

    watch: {
      $route () {
        if (this.$route.name === 'create-person') {
          this.$refs.customerModal.handleAddCustomer('person')
        } else if (this.$route.name === 'create-company') {
          this.$refs.customerModal.handleAddCustomer('company')
        }
      }
    },

    beforeRouteEnter (to, from, next) {
      if (to.params && to.params.customerId) {
        let customerId = to.params.customerId
        store.dispatch('fetchSelectedCustomer', customerId)
          .then(() => store.dispatch('fetchCustomersOverview'))
          .then(next)
          .catch(() => {
            Notify.create({ message: i18n.t('partner_not_found_notification'), type: 'warning' })
            next({ name: 'customers', params: { teamId: store.getters.activeTeam.id } })
          })
      } else {
        store.dispatch('fetchCustomersOverview')
          .then(next)
      }
    },

    beforeRouteUpdate (to, from, next) {
      if (to.params && to.params.customerId) {
        let customerId = to.params.customerId
        store.dispatch('fetchSelectedCustomer', customerId)
          .then(next)
          .catch(() => {
            Notify.create({ message: i18n.t('partner_not_found_notification'), type: 'warning' })
            next({ name: 'customers', params: { teamId: store.getters.activeTeam.id } })
          })
      } else {
        next()
      }
    },

    beforeRouteLeave (to, from, next) {
      Promise.all([this.deselectCustomer(), this.clearCheckedCustomers()])
        .then(next())
    },

    components: {
      CustomerExportModal,
      CustomerPopover,
      CustomerTable,
      AddCustomerModal
    }
  }
</script>
